import {Component, ViewEncapsulation, ElementRef, Inject, Input} from "@angular/core";

@Component({
  templateUrl: './header.component.html',
  selector: 'header',
  styleUrls: [ './header.component.scss' ],
  encapsulation: ViewEncapsulation.None
})

export class HeaderComponent {
}




// WEBPACK FOOTER //
// ./src/app/shared/decorator/header/header.component.ts